import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Banner from 'components/Banner';
import SectionContact from 'components/SectionContact';

import CheckIcon from 'images/icons/check.svg';

import { SolutionsDetail } from 'styles/solutions-detail';
import SolutionSteps from '../../components/SolutionSteps/SolutionSteps';

const SolutionSAFePage = ({ path }) => (
  <>
    <Meta title="SAFe Agile Transformation | Lean Transformation | ATC"
      description="Our SAFe Agile transformation service connects the SAFe framework and its practices with measurable outcomes your organization wants to achieve." />
    <Layout background="#ffffff" path={path}>
      <SolutionsDetail>
        <Banner
          backgroundSrc="solutions/safe-transformation-banner.jpg"
          title="SAFe (Lean) Transformation - Unleash your team’s potential."
          className="darken-image"
          style={{ paddingBottom: 100 }}
        >
          <p
            className="white-txt"
            style={{
              fontSize: 18,
              letterSpacing: 0.2,
              lineHeight: '28px',
            }}
          >
            DevOps unleashes the true potential of your teams by automating
            repetitive and error-prone manual tasks.
          </p>
          <Link
            to="/contact-us/"
            className="pink-btn"
            style={{ minWidth: 180 }}
          >
            <span>Schedule a demo</span>
          </Link>
          <a
            href="#brief"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window !== 'undefined')
                window.scrollb.scrollIntoView(document.getElementById('brief'));
            }}
            className="white-btn brief-btn"
          >
            <span>What to expect</span>
          </a>
        </Banner>

        <section className="principle-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <h2 className="medium-heading">
                  Leveraging digital is a priority
                </h2>
                <p className="white-txt">
                  Today, companies interact with their customers almost entirely
                  through applications and online services. Data that gets
                  generated through these digital touchpoints empower companies
                  to predict customer needs and offer customized solutions at
                  the right time. Leveraging digital is already your priority,
                  but are you deploying apps fast enough to consistently improve
                  user experience? Harness the power of automation to accelerate
                  the build-test-deploy-monitor cycle.
                </p>
              </div>
            </div>
          </div>
        </section>

        <SolutionSteps id="sageTransformation" flyText="SAFe Transformation"
          flyBoxImage="solutions/safe-box.jpg" />

        <section id="brief">
          <div className="grey-bg center">
            <div className="container">
              <div className="featured-partner-block">
                <h2 className="medium-heading black-txt">
                  Work better, not harder
                </h2>
                <p>
                  Lean-Agile methodology works to consistently improve quality,
                  reduce costs, and accelerate delivery. Lean-Agile
                  Transformation is a journey from the legacy waterfall model in
                  SDLC to an approach that promotes consistent and incremental
                  value-addition. By adapting time-boxed ‘sprints’, it is easier
                  for you to roll out new features and iteratively make it
                  better through user feedback.
                </p>
                <Link
                  to="/contact-us/"
                  className="pink-btn d-none d-md-inline-block"
                >
                  <span>Talk to an Expert</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="why-partner-main">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <h2 className="big-heading">
                    DevOps Management
                    <span className="pink">.</span>
                  </h2>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Communication</h3>
                        <p>Seamless knowledge transfer.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Efficiency</h3>
                        <p>
                          Break down complex processes into manageable
                          microservices.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Automation</h3>
                        <p>Promoting rapid deployments.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Monitoring</h3>
                        <p>Gain insights from logs and reporting.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SectionContact />
      </SolutionsDetail>
    </Layout>
  </>
);

SolutionSAFePage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionSAFePage;
